import getInLinksPage from "@/pageComponents/inlink";

const Page = getInLinksPage("board");

export default Page.PageComponent;
export const getServerSideProps = Page.getServerSideProps;
